



































import { Vue, Component, Prop } from 'vue-property-decorator';
import FieldContextMenuActions from '@/dealroom/fields/context-menu/components/FieldContextMenuActions.vue';
import FieldContextMenuBody from '@/dealroom/fields/context-menu/components/FieldContextMenuBody.vue';
import { IField } from '@/dealroom/fields/types/field';
import { IFieldMenuAction } from '@/dealroom/fields/context-menu/types/field-menu-action';
import { EFieldMenuActionType } from '@/dealroom/fields/context-menu/types/enums/field-menu-action-type';
import { EAlignFieldType } from '@/dealroom/fields/context-menu/types/enums/align-field-type';
import { IRecipient } from '@/types/Recipient';
import { IUser } from '@/types/User';
import { IDocumentPage } from '@/types/document-page';
import { EnumDocumentType } from '@/enums/DocumentType';

@Component({
  components: {
    FieldContextMenuBody,
    FieldContextMenuActions,
  },
})
export default class FieldContextMenu extends Vue {
  @Prop() fields!: IField[];
  @Prop() sender!: IUser;
  @Prop() recipients: IRecipient[];
  @Prop() pages: IDocumentPage[];

  @Prop() actions: IFieldMenuAction[];
  @Prop() textSizes: number[];
  @Prop() pageWidth: number;
  @Prop() documentType: EnumDocumentType;
  @Prop() flipped: boolean;

  selectedActionType: EFieldMenuActionType = this.defaultSelectedActionType;
  minHeight = 160;
  dynamicHeight = 0;

  get height(): string {
    if (this.dynamicHeight < this.minHeight) {
      return `${this.minHeight}px`;
    }
    return `${this.dynamicHeight}px`;
  }

  get defaultSelectedActionType(): EFieldMenuActionType {
    if (!this.actions || !this.actions.length) {
      return null;
    }
    return this.actions[0].type;
  }

  handleDeselectAll() {
    this.$emit('deselectAll');
  }

  handleSelectActionType(type: EFieldMenuActionType) {
    this.selectedActionType = type;
  }

  handleUpdate(payload: IField[]) {
    this.$emit('update', payload);
  }

  handleAlign(actionType: EAlignFieldType) {
    this.$emit('align', actionType);
  }

  handleDelete() {
    this.$emit('delete');
  }

  handleMove(payload: string) {
    this.$emit('move', payload);
  }

  handleTextSize(size: number) {
    this.$emit('textSize', size);
  }

  handleDuplicate() {
    this.$emit('duplicate');
  }

  mounted() {
    this.dynamicHeight = document.getElementById('actionsMenu').clientHeight;
  }
}
